"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTapeBuilderGeneratedLoanTapeNode = exports.isTapeBuilderNativeOperationNode = exports.isTapeBuilderNativeOperationType = exports.isTapeBuilderOrBBPLOperationNode = exports.isTapeBuilderCalcAgentOperationNode = exports.isTapeBuilderFileNode = exports.isTapeBuilderGeneratedTapeNode = exports.isTapeBuilderDbNode = exports.isTapeBuilderConfigTapeNode = exports.isTapeBuilderRawTapeNode = exports.isRawNodeType = exports.getFriendlyNameForNode = exports.getArtifactSlugForTapeNode = exports.getUITapeNodeByType = exports.getUITapeNodeByArtifactType = exports.getUINodeByType = exports.getTapeNodeByType = exports.getOperationNodeByType = exports.uiNodes = exports.tapeNodes = exports.operationNodes = void 0;
/* eslint-disable camelcase */
// here we import all the uiNodes
const common_1 = require("@finley-technologies/common");
const uinode_1 = require("./operations/attachHeader/uinode");
const uinode_2 = require("./operations/calcagent/uinode");
const uinode_3 = require("./operations/edit/uinode");
const uinode_4 = require("./operations/filter/uinode");
const uinode_5 = require("./operations/flatten/uinode");
const uinode_6 = require("./operations/join/uinode");
const uinode_7 = require("./operations/pdf2csv/uinode");
const uinode_8 = require("./operations/preFilter/uinode");
const uinode_9 = require("./operations/sanitize/uinode");
const uinode_10 = require("./operations/unzip/uinode");
const uinode_11 = require("./operations/verify/uinode");
const uinode_12 = require("./operations/xlsx2csv/uinode");
const uinode_13 = require("./tapes/config-tape/uinode");
const uinode_14 = require("./tapes/dbnode/uinode");
const uinode_15 = require("./tapes/forwarded-tape/uinode");
const uinode_16 = require("./tapes/generated-borrowing-base-report/uinode");
const uinode_17 = require("./tapes/generated-cash-balance-feed/uinode");
const uinode_18 = require("./tapes/generated-covenant-loan-tape/uinode");
const uinode_19 = require("./tapes/generated-financial-data/uinode");
const uinode_20 = require("./tapes/generated-funding-request/uinode");
const uinode_21 = require("./tapes/generated-loan-tape/uinode");
const uinode_22 = require("./tapes/generated-receivable-invoice/uinode");
const uinode_23 = require("./tapes/generated-receivable-response-tape/uinode");
const uinode_24 = require("./tapes/generated-repayment-tape/uinode");
const uinode_25 = require("./tapes/generated-supplemental-tape/uinode");
const uinode_26 = require("./tapes/intermediate-tape/uinode");
const uinode_27 = require("./tapes/org-provided-input/uinode");
const uinode_28 = require("./tapes/raw-cash-balance-feed/uinode");
const uinode_29 = require("./tapes/raw-loan-tape/uinode");
const uinode_30 = require("./tapes/raw-receivable-documentation/uinode");
const uinode_31 = require("./tapes/raw-repayment-tape/uinode");
const uinode_32 = require("./tapes/raw-supplemental-tape/uinode");
const uinode_33 = require("./tapes/valley-bank-ingest/uinode");
exports.operationNodes = {
    // pre-sanitie operations
    // these are operations that do not have tapedefinitions associated with them.
    operation_unzip: uinode_10.operation_unzip,
    operation_attachHeader: uinode_1.operation_attachHeader,
    operation_xlsx2Csv: uinode_12.operation_xlsx2Csv,
    operation_pdf2Csv: uinode_7.operation_pdf2Csv,
    operation_preFilter: uinode_8.operation_preFilter,
    // post sanitize operations
    // these are operations that have tapedefinitions associated with them.
    operation_sanitize: uinode_9.operation_sanitize,
    operation_edit: uinode_3.operation_edit,
    operation_filter: uinode_4.operation_filter,
    operation_flatten: uinode_5.operation_flatten,
    operation_join: uinode_6.operation_join,
    operation_calcAgent: uinode_2.operation_calcAgent,
    operation_verify: uinode_11.operation_verify,
};
const operationNodeArray = Object.values(exports.operationNodes);
exports.tapeNodes = {
    // Raw
    file_rawLoanTape: uinode_29.file_rawLoanTape,
    file_rawCashBalanceFeed: uinode_28.file_rawCashBalanceFeed,
    file_rawReceivableDocumentation: uinode_30.file_rawReceivableDocumentation,
    file_rawRepaymentTape: uinode_31.file_rawRepaymentTape,
    file_rawSupplementalTape: uinode_32.file_rawSupplementalTape,
    // special node to keep borrower config
    file_configTape: uinode_13.file_configTape,
    // intermediate/generated
    file_intermediateTape: uinode_26.file_intermediateTape,
    file_generatedLoanTape: uinode_21.file_generatedLoanTape,
    file_generatedCovenantLoanTape: uinode_18.file_generatedCovenantLoanTape,
    file_generatedCashBalanceFeed: uinode_17.file_generatedCashBalanceFeed,
    file_generatedRepaymentTape: uinode_24.file_generatedRepaymentTape,
    file_generatedReceivableResponseTape: uinode_23.file_generatedReceivableResponseTape,
    file_generatedBorrowingBaseReport: uinode_16.file_generatedBorrowingBaseReport,
    file_valley_bank_ingest: uinode_33.file_valley_bank_ingest,
    // data forwarding
    file_forwardedTape: uinode_15.file_forwardedTape,
    // Final
    file_generatedFundingRequest: uinode_20.file_generatedFundingRequest,
    file_generatedReceivableInvoice: uinode_22.file_generatedReceivableInvoice,
    file_generatedSupplementalTape: uinode_25.file_generatedSupplementalTape,
    file_financialData: uinode_19.file_financialData,
    file_orgProvidedInput: uinode_27.file_orgProvidedInput,
    // Special one for Monitor mode.
    db_node: uinode_14.db_node,
};
const tapeNodeArray = Object.values(exports.tapeNodes);
exports.uiNodes = [...operationNodeArray, ...tapeNodeArray];
const getOperationNodeByType = (nodeType) => {
    const uiNode = exports.operationNodes[nodeType];
    (0, common_1.finleyAssert)(uiNode, `No uiNode found for nodeType: ${nodeType}`);
    return uiNode;
};
exports.getOperationNodeByType = getOperationNodeByType;
const getTapeNodeByType = (nodeType) => {
    const uiNode = exports.tapeNodes[nodeType];
    (0, common_1.finleyAssert)(uiNode, `No uiNode found for nodeType: ${nodeType}`);
    return uiNode;
};
exports.getTapeNodeByType = getTapeNodeByType;
const getUINodeByType = (nodeType) => {
    const uiNode = exports.uiNodes.find((node) => node.nodeType === nodeType);
    (0, common_1.finleyAssert)(uiNode, `No uiNode found for nodeType: ${nodeType}`);
    return uiNode;
};
exports.getUINodeByType = getUINodeByType;
const getUITapeNodeByArtifactType = (artifactType) => {
    const uiNode = tapeNodeArray.find((node) => !node.isOperation && node.artifactType === artifactType);
    (0, common_1.finleyAssert)(uiNode, `No uiNode found for artifactType: ${artifactType}`);
    (0, common_1.finleyAssert)(!uiNode.isOperation, `isOperation uiNode found for artifactType: ${artifactType}`);
    return uiNode;
};
exports.getUITapeNodeByArtifactType = getUITapeNodeByArtifactType;
const getUITapeNodeByType = (nodeType) => {
    const uiNode = tapeNodeArray.find((node) => node.nodeType === nodeType);
    (0, common_1.finleyAssert)(uiNode, `No uiNode found for nodeType: ${nodeType}`);
    (0, common_1.finleyAssert)(!uiNode.isOperation, `!isOperation uiNode found for nodeType: ${nodeType}`);
    (0, common_1.finleyAssert)(uiNode.nodeType === nodeType, 'nodeType mismatch');
    return uiNode;
};
exports.getUITapeNodeByType = getUITapeNodeByType;
const getArtifactSlugForTapeNode = (tapeNode) => {
    const uiNode = (0, exports.getUITapeNodeByType)(tapeNode.metadata.tapeBuilderNodeType);
    (0, common_1.finleyAssert)(!uiNode.isOperation, 'node cannot be operation');
    return uiNode.getArtifactSlug(tapeNode);
};
exports.getArtifactSlugForTapeNode = getArtifactSlugForTapeNode;
const getFriendlyNameForNode = (node) => {
    return (0, exports.getUINodeByType)(node.metadata.tapeBuilderNodeType).getFriendlyName(node);
};
exports.getFriendlyNameForNode = getFriendlyNameForNode;
const isRawNodeType = (nodeType) => {
    const uiNode = (0, exports.getUINodeByType)(nodeType);
    return !uiNode.isOperation && uiNode.isRaw;
};
exports.isRawNodeType = isRawNodeType;
const isTapeBuilderRawTapeNode = (obj) => {
    return (0, exports.isRawNodeType)(obj.metadata.tapeBuilderNodeType);
};
exports.isTapeBuilderRawTapeNode = isTapeBuilderRawTapeNode;
const isTapeBuilderConfigTapeNode = (obj) => {
    return obj.metadata.tapeBuilderNodeType === 'file_configTape';
};
exports.isTapeBuilderConfigTapeNode = isTapeBuilderConfigTapeNode;
const isTapeBuilderDbNode = (obj) => {
    return obj.metadata.tapeBuilderNodeType === 'db_node';
};
exports.isTapeBuilderDbNode = isTapeBuilderDbNode;
const isTapeBuilderGeneratedTapeNode = (obj) => {
    const uiNode = (0, exports.getUINodeByType)(obj.metadata.tapeBuilderNodeType);
    return !uiNode.isOperation && !uiNode.isRaw && !(0, exports.isTapeBuilderDbNode)(obj);
};
exports.isTapeBuilderGeneratedTapeNode = isTapeBuilderGeneratedTapeNode;
const isTapeBuilderFileNode = (obj) => {
    return (0, exports.isTapeBuilderRawTapeNode)(obj) || (0, exports.isTapeBuilderGeneratedTapeNode)(obj);
};
exports.isTapeBuilderFileNode = isTapeBuilderFileNode;
const isTapeBuilderCalcAgentOperationNode = (obj) => {
    return obj.metadata.tapeBuilderNodeType === uinode_2.operation_calcAgent.nodeType;
};
exports.isTapeBuilderCalcAgentOperationNode = isTapeBuilderCalcAgentOperationNode;
const isTapeBuilderOrBBPLOperationNode = (obj) => {
    const uiNode = (0, exports.getUINodeByType)(obj.metadata.tapeBuilderNodeType);
    return uiNode.isOperation;
};
exports.isTapeBuilderOrBBPLOperationNode = isTapeBuilderOrBBPLOperationNode;
const tapeBuilderNativeOperationTypes = [
    'tapebuilder_postSanitize',
    'tapebuilder_preSanitize',
];
const isTapeBuilderNativeOperationType = (nodeType) => {
    const uiNode = (0, exports.getUINodeByType)(nodeType);
    return (uiNode.isOperation &&
        tapeBuilderNativeOperationTypes.includes(uiNode.operationType));
};
exports.isTapeBuilderNativeOperationType = isTapeBuilderNativeOperationType;
const isTapeBuilderNativeOperationNode = (obj) => {
    return (0, exports.isTapeBuilderNativeOperationType)(obj.metadata.tapeBuilderNodeType);
};
exports.isTapeBuilderNativeOperationNode = isTapeBuilderNativeOperationNode;
const isTapeBuilderGeneratedLoanTapeNode = (obj) => {
    return obj.metadata.tapeBuilderNodeType === uinode_21.file_generatedLoanTape.nodeType;
};
exports.isTapeBuilderGeneratedLoanTapeNode = isTapeBuilderGeneratedLoanTapeNode;
//# sourceMappingURL=uiNodes.js.map